import React from 'react';
import { useTheme } from '@material-ui/core';
import FormML from './FormML';
import StepTwoStyled from './StepTwoMLStyles';

export default (props) => {
  const theme = useTheme();
  return (
    <StepTwoStyled theme={theme}>
      <FormML {...props} />
    </StepTwoStyled>
  );
};
